import setStyles from '@/constants/Forms/setStyles'
import {statusCompany, visaQuote} from '@/constants/contactCompany'
import {UNDER_RENEWAL} from '@/constants/expireStatus'
import personalBanks from '@/constants/personalBanks'
import placesOfRegistration from '@/constants/placesOfRegistartion'

const inputsGroupOne = [
  {
    id: 'name',
    label: 'Company name',
    type: 'string',
    model: 'name',
    require: true,
    styleError: {
      right: '10px'
    }
  },
  {
    id: 'status',
    label: 'Status',
    type: 'select',
    model: 'status',
    require: true,
    default: statusCompany[0],
    list: statusCompany,
    labelList: 'name',
    searchable: false
  },
  {
    id: 'visa',
    label: 'Visa Quota',
    type: 'select',
    model: 'visaQuote',
    require: true,
    default: visaQuote[0],
    list: visaQuote,
    labelList: 'name',
    searchable: false
  },
  {
    id: 'licenseDate',
    label: 'Formed on',
    type: 'date',
    noDefaultDateStart: true,
    model: 'formedOn',
    styleProps: 'iconEnd'
  },
  {
    id: 'trn',
    label: 'TRN',
    type: 'string',
    model: 'trn'
  },
  {
    id: 'formedIn',
    label: 'Formed in',
    type: 'select',
    model: 'formedIn',
    require: true,
    list: placesOfRegistration,
    default: placesOfRegistration[0],
    labelList: 'name',
    searchable: false,
    styleError: {
      right: '10px'
    }
  },
  {
    id: 'companyStamp',
    label: 'Company stamp',
    type: 'stamp',
    filename: 'stamp',
    model: 'uploadFile',
    columns: '1fr 1fr',
    gap: '10px'
  }
]

const inputsGroupTwo = [
  {
    id: 'licenseNo',
    label: 'License',
    suffix: 'No.',
    type: 'string',
    array: true,
    model: 'licenseNo',
    group: 'license',
    counter: 0,
    styleProps: 'iconEnd',
    styleError: {
      right: '50px'
    }
  },
  {
    id: 'licenseDate',
    label: 'License',
    suffix: 'Exp Date',
    type: 'date',
    noDefaultDateStart: true,
    editableDate: {
      prop: 'expireStatus',
      equal: UNDER_RENEWAL.id
    },
    model: 'licenseDate',
    group: 'license',
    counter: 0,
    styleProps: 'iconEnd',
    styleError: {
      right: '85px'
    }
  },
  {
    id: 'licenseFile',
    label: 'License file',
    type: 'stamp',
    filename: 'file',
    model: 'uploadFile',
    group: 'license',
    counter: 0,
    styleProps: 'iconEnd'
  },
  {
    id: 'licenseId',
    model: 'id',
    group: 'license',
    counter: 0,
    hide: true
  },
  {
    id: 'licenseStatus',
    model: 'expireStatus',
    group: 'license',
    counter: 0,
    hide: true
  },
  {
    id: 'estCard.estCardNo',
    label: 'Est Card No.',
    type: 'string',
    model: 'estCard.estCardNo'
  },
  {
    id: 'estCardDate.estCardDate',
    label: 'Est Card Exp Date',
    type: 'date',
    noDefaultDateStart: true,
    model: 'estCard.estCardDate',
    styleProps: 'iconEnd'
  },
  {
    id: 'estCardStatus',
    model: 'estCard.expireStatus',
    hide: true
  },
  {
    id: 'estCardDate.uploadFile',
    label: 'Est Card File',
    type: 'stamp',
    filename: 'card',
    model: 'estCard.uploadFile',
    styleProps: 'iconEnd',
    styleError: {
      top: '10px',
      right: '0'
    }
  }
]

const inputsGroupThree = [
  {
    id: 'officeAddress.address',
    label: 'Office Address',
    type: 'textarea',
    model: 'officeAddress.address',
    styleProps: 'high'
  },
  {
    id: 'officeAddress.leaseExp',
    label: 'Lease Exp Date',
    type: 'date',
    noDefaultDateStart: true,
    model: 'officeAddress.leaseExp',
    styleProps: 'iconEnd'
  },
  {
    id: 'officeAddressStatus',
    model: 'officeAddress.expireStatus',
    hide: true
  },
  {
    id: 'officeAddress.uploadFile',
    label: 'Lease Contract',
    filename: 'contract',
    type: 'stamp',
    model: 'officeAddress.uploadFile',
    styleProps: 'iconEnd',
    styleError: {
      top: '10px',
      right: '0'
    }
  },
  {
    id: 'eChannel.isActive',
    label: 'E-channel',
    type: 'radio',
    model: 'eChannel.isActive',
    radio: [
      {value: true, checked: true, text: 'Yes'},
      {value: false, text: 'No'}
    ]
  },
  {
    id: 'eChannel.date',
    label: 'E-channel Exp Date',
    type: 'date',
    noDefaultDateStart: true,
    model: 'eChannel.date',
    styleProps: 'iconEnd',
    display: 'eChannel.isActive'
  },
  {
    id: 'eChannelStatus',
    model: 'eChannel.expireStatus',
    hide: true
  },
  {
    id: 'esrReportable',
    label: 'ERS Reportable',
    type: 'radio',
    model: 'esrReportable',
    radio: [
      {value: true, checked: true, text: 'Yes'},
      {value: false, text: 'No'}
    ]
  }
]

const inputsGroupFour = [
  {
    id: 'auditExpDate',
    label: 'Audit Exp Date',
    type: 'date',
    noDefaultDateStart: true,
    model: 'auditExpDate',
    styleProps: 'iconEnd'
  },
  {
    id: 'aofcExpDate',
    label: 'AOFC Exp Date',
    type: 'date',
    noDefaultDateStart: true,
    model: 'aofcExpDate',
    styleProps: 'iconEnd'
  },
  {
    id: 'licenseActivities',
    label: 'License Activities',
    type: 'textarea',
    model: 'licenseActivities',
    styleProps: 'high',
    styleError: {
      top: '8px',
      right: '10px'
    }
  },
  {
    id: 'manager',
    label: 'Manager',
    type: 'string',
    model: 'manager',
    styleError: {
      right: '10px'
    }
  },
  {
    id: 'secretary',
    label: 'Secretary',
    type: 'string',
    model: 'secretary'
  },
  {
    id: 'director',
    label: 'Director',
    type: 'string',
    model: 'directorName',
    group: 'director',
    array: true,
    styleProps: 'iconEnd',
    counter: 0
  },
  {
    id: 'shareholder',
    label: 'Shareholder',
    type: 'string',
    model: 'shareholderName',
    group: 'shareholder',
    array: true,
    styleProps: 'iconEnd',
    counter: 0,
    styleError: {
      right: '50px'
    }
  },
  {
    id: 'loginDetails',
    label: 'Login details',
    type: 'textarea',
    model: 'loginDetails',
    styleProps: 'high'
  }
]

const inputsGroupFive = [
  {
    id: 'bankName',
    label: 'Bank',
    type: 'select',
    array: true,
    model: 'bankName',
    group: 'banks',
    counter: 0,
    styleProps: 'iconEnd',
    list: personalBanks,
    labelList: 'name',
    searchable: false

  },
  {
    id: 'bankNo',
    label: 'Bank A/C',
    suffix: 'No.',
    type: 'string',
    model: 'bankNo',
    group: 'banks',
    counter: 0,
    styleProps: 'iconEnd'
  }
]

const inputsGroupSix = [
  {
    id: 'bbRenewal',
    label: 'BB Renewal',
    type: 'string',
    model: 'bbRenewal'
  },
  {
    id: 'govtRenewalFee',
    label: 'Govt Renewal Fee',
    type: 'string',
    model: 'govtRenewalFee'
  },
  {
    id: 'bbAdmin',
    label: 'BB Admin',
    type: 'string',
    model: 'bbAdmin'
  },
  {
    id: 'dateLastUpdate',
    label: 'Last Update Date',
    type: 'date',
    noDefaultDateStart: true,
    model: 'dateLastUpdate',
    styleProps: 'iconEnd'
  }
]

const styles = {
  default: {
    gridTemplateColumns: '1fr 165px',
    gridGap: '10px',
    alignItems: 'center'
  },
  iconEnd: {
    gridTemplateColumns: '1fr 125px 30px',
    gridGap: '10px',
    alignItems: 'center'
  },
  high: {
    gridTemplateColumns: '1fr 165px',
    alignItems: 'start'
  }
}

const contactsCompanyInputs = [
  {
    id: 1,
    border: false,
    data: setStyles(inputsGroupOne, styles)
  },
  {
    id: 2,
    border: true,
    data: setStyles(inputsGroupTwo, styles)
  },
  {
    id: 3,
    border: true,
    data: setStyles(inputsGroupThree, styles)
  },
  {
    id: 4,
    border: false,
    data: setStyles(inputsGroupFour, styles)
  }
]

const contactsCompanyInputsFinances = [
  {
    id: 5,
    border: true,
    data: setStyles(inputsGroupFive, styles)
  }
]

const contactCompanyInputsRenewal = [
  {
    id: 6,
    border: false,
    data: setStyles(inputsGroupSix, styles)
  }
]

const allInputs = [
  ...inputsGroupOne,
  ...inputsGroupTwo,
  ...inputsGroupThree,
  ...inputsGroupFour
]

const financesInputs = [
  ...inputsGroupFive
]

const renewalInputs = [
  ...inputsGroupSix
]

export {
  contactsCompanyInputs,
  contactsCompanyInputsFinances,
  contactCompanyInputsRenewal,
  allInputs,
  financesInputs,
  renewalInputs
}



// WEBPACK FOOTER //
// ./src/constants/Forms/contactCompanyForm.js